export var CSV_COLUMNS = [
    "userId",
    "submittedAt",
    "serviceSlug",
    "answers",
];
